var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconGradientLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3102 60.3357C37.6157 61.7593 36.7477 62.9861 35.7407 63.9815C34.7107 64.9884 33.5764 65.8449 32.3727 66.5162C31.169 67.1875 29.9074 67.6852 28.6227 67.9977C24.8727 68.8889 21.3542 68.4838 18.3333 66.956C16.3426 65.9491 14.5949 64.5718 13.1366 62.8704C11.6667 61.1574 10.4977 59.1551 9.65279 56.9213C8.80788 54.6875 8.37964 52.3264 8.37964 49.8843C8.37964 47.6389 8.73844 45.4051 9.44445 43.2292C10.1505 41.0648 11.2037 39.0857 12.581 37.3495C13.9583 35.625 15.6713 34.213 17.6852 33.1482C19.6759 32.0949 22.0255 31.5509 24.6412 31.5509C25.8333 31.5509 27.0602 31.6898 28.2986 31.956C29.5139 32.2222 30.7176 32.662 31.8519 33.2755C32.9861 33.8889 34.0625 34.6875 35.0347 35.6713C36.007 36.6435 36.8519 37.8588 37.5463 39.2824L37.8935 39.9884L42.7315 37.0486L42.4537 36.4699C40.9838 33.3912 38.7269 30.8681 35.7407 28.9468C32.7546 27.0255 29.1088 26.0648 24.9074 26.0648C21.3657 26.0648 18.1597 26.7708 15.3588 28.1713C12.581 29.5602 10.1968 31.3889 8.29862 33.5995C6.40047 35.8102 4.93056 38.3449 3.93519 41.1458C2.93982 43.9468 2.44214 46.794 2.44214 49.6065C2.44214 52.6042 2.98612 55.5903 4.06251 58.4722C5.1389 61.3542 6.66668 63.9699 8.61112 66.2384C10.5556 68.5069 12.9051 70.3819 15.6019 71.794C18.3102 73.2176 21.331 73.9352 24.5833 73.9352C26.4005 73.9352 28.2755 73.6921 30.1505 73.206C32.0255 72.7199 33.831 72.0023 35.5093 71.0764C37.1991 70.1389 38.75 68.9931 40.1157 67.6389C41.5046 66.2732 42.6042 64.6644 43.3681 62.8588L43.6227 62.2454L38.6458 59.6759L38.3218 60.3357H38.3102Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9722 73.8773V34.6065L73.5301 64.9884H70.7639L53.3218 34.6065V73.8773H48.6111V26.0532H53.4606L72.1181 58.7847L90.9144 26.0532H95.6944V73.8773H90.9838H90.9722Z",
    fill: "url(#paint0_linear_993_1943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_1943",
    x1: 93.6574,
    y1: 73.75,
    x2: 62.0255,
    y2: 38.7847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D49D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E55D78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconGradientLight);
export default __webpack_public_path__ + "static/media/logoIconGradientLight.da8e52015e6b8ba86545461294dd30a3.svg";
export { ForwardRef as ReactComponent };